import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TechnicalPerformancePCRoutingModule } from './technical-performance-pc-routing.module';
import { TenchnicalPerformancePCComponent } from './tenchnical-performance-pc.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { CustomDatePickerModule } from 'src/app/shared/components/custom-date-picker/custom-date-picker.module';
import { CustomDropdownModule } from 'src/app/shared/components/custom-dropdown/custom-dropdown.module';
import { CustomInputModule } from 'src/app/shared/components/custom-input/custom-input.module';
import { CustomTimpickerModule } from 'src/app/shared/components/custom-timpicker/custom-timpicker.module';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { CharterPerformancePCRoutingModule } from '../charter-performance-pc/charter-performance-pc-routing.module';
import { PcMultiSelectFilterModule } from 'src/app/shared/components/pc-multi-select-filter/pc-multi-select-filter.module';
import { AppBackButtonModule } from 'src/app/shared/components/app-back-button/app-back-button.module';

@NgModule({
  declarations: [TenchnicalPerformancePCComponent],
  imports: [
    CommonModule,
    TechnicalPerformancePCRoutingModule,
    CharterPerformancePCRoutingModule, FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    MatPaginatorModule,
    MatSortModule,
    MatAutocompleteModule,
    MatInputModule,
    CustomDropdownModule,
    CustomDatePickerModule,
    CustomTimpickerModule,
    CustomInputModule,
    PcMultiSelectFilterModule,
    AppBackButtonModule,
  ]
})
export class TechnicalPerformancePCModule { }